import {getStationCode} from "../network/NetworkUtil";
import {ROUTE_DATA_CACHE_KEY} from "./LocalStorageKeys";
import {isArrayEquals} from "./Util";
import {CACHE_TTL} from "./Constants";
import {STOWED} from "./EntityStatusManager";
import {DEPART_TAB_METRIC_KEY, logOperationalMetric, MetricType, UPDATE_ROUTE_TO_STOWED_IN_CACHE} from "./MetricUtil";


/**
 * Saves data in local storage and set expiry time.
 */
export function setDataWithExpiry(key, value) {
    try {
        const currTime = (value.lastUpdated === undefined)? new Date().getTime() : value.lastUpdated
        const record = {
            data: value.record,
            lastUpdated: currTime,
            expiry: currTime + CACHE_TTL
        }
        localStorage.setItem(key, JSON.stringify(record));
    } catch (e) {
    }
}

/**
 * Retrieves data from local storage if not expired, null otherwise.
 */
export function getDataWithExpiry(key) {
    const response = {cachedData: null, lastUpdated: null}
    try {
        const storedJson = localStorage.getItem(key) || null;
        if (!storedJson) {
            return response
        }
        const record = JSON.parse(storedJson)
        const now = new Date()

        // compare the expiry time of the item with the current time
        if (now.getTime() > record.expiry) {
            // cache is expired
            localStorage.removeItem(key)
            return response
        }
        response.cachedData = record.data
        response.lastUpdated = record.lastUpdated
        return response;
    } catch (e) {
        return response;
    }
}

/**
 * If cache is present for key, this method return number of milliseconds pending until expiry.
 * Otherwise returns 0.
 */
export function getRemainingTTL(key) {
    try {
        const storedJson = localStorage.getItem(key) || null;
        if (!storedJson) {
            return 0;
        }
        const record = JSON.parse(storedJson)
        const now = new Date()

        // compare the expiry time of the item with the current time
        if (now.getTime() < record.expiry) {
            return record.expiry - now.getTime();
        }
    } catch (e) {
    }
    return 0;
}

/**
 * Checks whether the route cache is valid or not based on the expiry time
 */
export function isRouteCacheValid(xptNodes) {
    const {cachedData} = getDataWithExpiry(ROUTE_DATA_CACHE_KEY);
    const stationCode = getStationCode();
    return cachedData && isArrayEquals(xptNodes, cachedData.xptNodes) && stationCode === cachedData.stationCode;
}

/**
 * Keep expiry of data same since we expiry is tracked at the cache level.
 */
export function updateRouteToStowedInCacheOnReadyForDispatch(routeId) {
    const startTime = Date.now();
    const stationCode = getStationCode();
    const metricName = UPDATE_ROUTE_TO_STOWED_IN_CACHE;
    try {
        const {cachedData, lastUpdated} = getDataWithExpiry(ROUTE_DATA_CACHE_KEY);
        if (cachedData == null || cachedData.response == null || cachedData.response.routes == null) {
            return;
        }
        cachedData.response.routes.forEach(route => {
            if (route.routeId === routeId) {
                route.routeStatus = STOWED;
            }
        })
        const record = {
            data: cachedData,
            lastUpdated: lastUpdated,
            expiry: lastUpdated + CACHE_TTL
        }
        localStorage.setItem(ROUTE_DATA_CACHE_KEY, JSON.stringify(record));
        logOperationalMetric(startTime, stationCode, DEPART_TAB_METRIC_KEY, metricName, MetricType.SUCCESS);
    } catch (e) {
        logOperationalMetric(startTime, stationCode, DEPART_TAB_METRIC_KEY, metricName, MetricType.FAILED);
    }
}



// WEBPACK FOOTER //
// ./src/components/util/CacheManager.js